import JobFeeSource from '@/models/Jobs/JobFeeSource';
import JobType from '@/models/Jobs/JobType';
import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateJobRequiremnentsRequest extends BaseUpdateRequest {
    primaryPositionId: string;
    secondaryPositionIds: string[] = [];
    primarySkillIds: string[] = [];
    secondarySkillIds: string[] = [];
    primaryQualificationIds: string[] = [];
    secondaryQualificationIds: string[] = [];
}